<template>
    <div v-if="loading">
        <v-container
            fluid
            pa-3
            my-3
        >
            <v-layout
                column
                align-center
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                    size="50"
                />
            </v-layout>
        </v-container>
    </div>
    <div v-else-if="!loading && error">
        <v-container
            fluid
            pa-3
            my-3
        >
            <v-layout
                column
                align-center
            >
                <v-icon
                    color="primary"
                    size="50"
                >
                    fas fa-exclamation-triangle
                </v-icon>
                <span class="headline mt-3 font-weight-light">
                    {{ error }}
                </span>
            </v-layout>
        </v-container>
    </div>
    <div v-else>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        }
    }
}
</script>

<style>

</style>
